export const SUSTAINABILITY_DATA = {
  co2Reduction: "15% reduction in carbon footprint",
  waterSaved: "1.2M gallons annually",
  wasteReduction: "Repurposes 1.4M tons of brewery waste",
};

export const MARKET_COMPARISON_DATA = [
  { name: "Regular Heinz", protein: "0g", sugar: "Standard", price: "$3.79" },
  { name: "Competitor A", protein: "0g", sugar: "Standard", price: "$3.49" },
  { name: "Competitor B", protein: "0g", sugar: "Standard", price: "$3.89" },
];
